import type { IUseCase } from 'shared-kernel';
import type { ISessionRepository } from '../../../domain/ports';
import type { RevokeAllSessionsData } from '../../dto/dtos';

export class RevokeAllSessionsUseCase implements IUseCase<RevokeAllSessionsData, void> {
  constructor(
    private readonly sessionRepository: ISessionRepository,
  ) {}

  async execute(input: RevokeAllSessionsData): Promise<void> {
    const response = await this.sessionRepository.revokeAllSessions(input);

    if (!response.succes) {
      throw new Error(response.message || 'Echec de la revocation des sessions');
    }
  }
}
